<template>
  <div class="py-4 px-6">
    <template v-if="enter">
      <div class="text-2xl my-6 font-medium text-folyo">
        Get your Guide now!
      </div>

      <div class="my-6" :class="{'text-red': ('fname' in errors)}">
        <label for="vorname" class="block text-base font-medium">
          Vorname *
        </label>
        <input :class="{'border-red': ('fname' in errors)}" class="w-full text-2xl p-2 my-1 border" type="text" name="vorname" id="vorname"
          v-model="form.fname">
        <div v-if="('fname' in errors)" class="text-xs">
          <p v-for="error in errors.fname" :key="error">{{error}}</p>
        </div>
      </div>

      <div class="my-6" :class="{'text-red': ('sname' in errors)}">
        <label for="nachname" class="block text-base font-medium">
          Nachname *
        </label>
        <input :class="{'border-red': ('sname' in errors)}" class="w-full text-2xl p-2 my-1 border" type="text" name="nachname" id="nachname"
          v-model="form.sname">
        <div v-if="('sname' in errors)" class="text-xs">
          <p v-for="error in errors.sname" :key="error">{{error}}</p>
        </div>
      </div>

      <div class="my-6" :class="{'text-red': ('email' in errors)}">
        <label for="email" class="block text-base font-medium">
          Firmen E-Mail *
        </label>
        <input :class="{'border-red': ('email' in errors)}" class="w-full text-2xl p-2 my-1 border" type="email" name="email" id="email"
          v-model="form.email">
        <div v-if="('email' in errors)" class="text-xs">
          <p v-for="error in errors.email" :key="error">{{error}}</p>
        </div>
      </div>

      <div class="text-xs my-12">
        <div class="my-4">
          * Pﬂichtfelder
        </div>

        <div class="my-4">
          Mit der Übermittlung des Formulars stimmen Sie zu dass Folyo Ihre Daten verarbeitet, und Sie bezgl. der Produkte von Folyo
          kontaktiert.
        </div>

        <div class="my-4">
          Für weitere Informationen wie Sie sich abmelden können und wie wir Ihre Daten schützen und respektieren, sehen Sie sich bitte
          unsere
          <a href="https://getfolyo.com/de/privacy/" target="_blank" class="text-folyo">Datenschutzerklärung</a> an.
        </div>
      </div>

      <button class="p-2 bg-folyo text-white w-full text-2xl font-medium" @click="submit">
        Jetzt herunterladen
      </button>
    </template>
    <template v-else>
      <div class="text-2xl my-6 font-medium text-folyo">
        Download:
      </div>
      <a href="http://static.getfolyo.com/media-guide/folyo_brightscope_ooh_media_guide.pdf" 
        class="text-black no-underline"
        target="_blank">
          Meida Guide 2018
      </a>
      <p class="text-xs my-6 text-grey">© Brightscope 2018</p>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import domains from './free_email_provider_domains.json'

export default {
  name: 'app',
  data () {
    return {
      form: {
        'fname': '',
        'sname': '',
        'email': ''
      },
      errors: {},
      enter: true
    }
  },
  methods: {
    submit () {
      if (this.isValid()) {
        this.send(this.form)
      }
    },
    isValid () {
      let valid = true
      this.errors = {}
      if (!this.form.fname.length) {
        this.errors['fname'] = ['Ein Pflichtfeld wurde leer gelassen']
        valid = false
      }
      if (!this.form.sname.length) {
        this.errors['sname'] = ['Ein Pflichtfeld wurde leer gelassen']
        valid = false
      }
      var email = []
      if (!this.form.email.length) {
        email.push('Ein Pflichtfeld wurde leer gelassen')
        valid = false
      }
      var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!EMAIL_REGEX.test(this.form.email)) {
        email.push('Falsches E-Mail-Adressformat')
        valid = false
      }
      var EMAIL_DOMAINS = new RegExp(domains.join('|'))
      if (EMAIL_DOMAINS.test(this.form.email)) {
        email.push('E-Mail ist keine Firmen E-Mail')
        valid = false
      }
      if (email.length) {
        this.errors['email'] = email
      }
      return valid
    },
    send () {
      let data = this.form
      data.source = 'Brightscope Media Guide'

      axios
        .post('marketing/brightscope', data)
        .then((r) => {
          this.enter = false
        })
    }
  }
}
</script>

<style src="./styles/main.css"></style>
<style lang='stylus' src="./styles/custom.styl"></style>



// WEBPACK FOOTER //
// src/App.vue